<a [routerLink]="'/catalogue/' + dropdown.slug">
  <div class="item-container">
    <p><strong> {{ dropdown.label }} </strong></p>
    <div [style.background-image]="'url(./assets/images/'+ image +')'" class="image"></div>
    <a class="btn btn-primary text-white" href="/catalogue/{{dropdown.slug}}"> {{dropdown.nbProducts}} Article(s)</a>
  </div>
</a>
